import { get } from "./http";

export const getBanner = (params) =>
  get("/api/portalhome/getbannerlist", params);
export const getDynamicDetail = (params) =>
  get("/api/portalhome/getdynamicdetail", params);

export const getdynamiclist = (params) =>
  get("/api/portalhome/getdynamiclist", params);

export const getOrganizeGroupList = () => get("/api/portalhome/getorganizegrouplist");
